import swal from 'sweetalert';
import { baseApiAxios, showError } from './api';
import { isSearchEnabled } from './search_settings';
import {
  addCopyButton,
  addLoadAccountDetailsButton,
  addToast,
  checkValueAgainstList,
  loadRegionsAndUpdateDropdown,
  configureTableColumns,
  rowDetailsClickHandler,
  addLinkHostedZoneIdButton,
  showErrorFromApiOperation,
  hasAccess,
  removeDisabledOptions,
  displayError,
  displayErrorPopup,
  displaySuccessPopup,
  fetchDNS,
  scrollToPosition,
} from './main';
import { addButtonSpinner, addSpinner, addTableSpinner, removeSpinners } from './sidebar';
import { accountIdPattern } from './accounts';
import { centralFillVPCs, centralLoadVPCs } from './networks';
import HostedZoneTabs from '../../jsx/components/forms/HostedZoneTabs';
import {
  initDataTable,
  updateTableFooter,
  exportButtons,
  resetTableButton,
  reloadTableButton,
  col,
  selectColumn,
} from './datatable';

export const zoneTableColumns = [
  { id: 'select_col' },
  { id: 'domain_name_col', name: 'Domain Name' },
  { id: 'aws_account_id_col', name: 'Account ID' },
  { id: 'zone_id_col', name: 'Hosted Zone ID' },
  { id: 'zone_type_col', name: 'Hosted Zone Type' },
  { id: 'creation_date_col', name: 'Creation Date' },
  { id: 'records_col', name: 'Number of Records' },
  { id: 'ns_records_col', name: 'Number of NS Records' },
  { id: 'vpcs_col', name: 'Number of Associated VPCs' },
  { id: 'query_logging_configs_col', name: 'Number of Query Logging Configs' },
  { id: 'status_col', name: 'Status' },
  { id: 'status_update_col', name: 'Last Status Update (UTC)' },
  { id: 'actions_col', name: 'Actions' },
];

const hostedZonesDetailsAttributes = [
  'fqdn',
  'account_id',
  'zone_id',
  'zone_type',
  'creation_date',
  'numbers',
  'status',
  'status_update',
];

const dnsDropdownColumns = ['zone_type', 'status'];
const dnsSearchColumns = [
  'fqdn',
  'account_id',
  'zone_id_col',
  'creation_date',
  'records_col',
  'ns_records_col',
  'vpcs_col',
  'query_logging_configs_col',
  'status_update_col',
];

const dnsSearchColumnsNumbers = [
  'numbers.records',
  'numbers.ns_records',
  'numbers.vpcs',
  'numbers.query_logging_configs',
];

let dashboardShowAllHostedZones = false;

export function hideZoneEditForm() {
  $('#edit-zone-form').hide();
}

function addDNSRowButtons(td, _cellData, rowData, row) {
  const buttons = $('<div class="table-action-button-group">').appendTo(td);
  const accessibleDNS = hasAccess(rowData.account_id, ['manage_dns']);
  if (['AccountDeleted'].indexOf(rowData.status) < 0) {
    // TRIGGER UPDATE BUTTON
    buttons.append(
      $('<button class="btn btn-custom btn-xs" data-bs-toggle="tooltip" title="Trigger DB Update">')
        .on('click', () => triggerHostedZoneUpdate(row))
        .append('<i class="fas fa-sync-alt">'),
    );
  }

  if (accessibleDNS && ['AccountDeleted', 'NoSuchHostedZone'].indexOf(rowData.status) < 0) {
    // DELETE BUTTON
    buttons.append(
      $(
        '<button class="btn btn-custom btn-xs" data-bs-toggle="tooltip" title="Delete Hosted Zone"' +
          (accessibleDNS ? '' : ' disabled ') +
          '>',
      )
        .on('click', () => deleteZoneOrder(rowData))
        .append('<i class="fas fa-trash-alt">'),
    );
  } else {
    // DELETE FROM DB BUTTON
    buttons.append(
      $(
        '<button class="btn btn-custom btn-xs" data-bs-toggle="tooltip" title="Delete Hosted Zone From DB"' +
          (accessibleDNS ? '' : ' disabled ') +
          '>',
      )
        .on('click', async () => {
          await baseApiAxios.deleteHostedZoneFromDB(rowData.fqdn);
          addToast(
            'Hosted Zone deletion from DB',
            `Successfully requested deletion of hosted zone ${rowData.fqdn} from DB.`,
            6000,
          );
        })
        .append('<i class="fas fa-trash-alt">'),
    );
  }

  return buttons;
}

export function initDnsTable(tableId) {
  configureTableColumns(tableId, zoneTableColumns);

  let permissions = localStorage.permissions ? localStorage.permissions : false;

  const hasPermissionToViewAll =
    checkValueAgainstList('manage_accounts', permissions) ||
    checkValueAgainstList('view_all_accounts', permissions) ||
    checkValueAgainstList('manage_dns', permissions) ||
    localStorage.account_areas;

  $('#show-all-hostedzones-div').toggleClass('d-none', !hasPermissionToViewAll);

  $('#show-all-hostedzones-switch')
    .attr('checked', dashboardShowAllHostedZones)
    .on('change', function () {
      if (dashboardShowAllHostedZones !== this.checked) {
        dashboardShowAllHostedZones = this.checked;
        this.disabled = true;
        $('#' + tableId)
          .DataTable()
          .clear();
        loadDnsData(tableId);
      }
    });

  const dt = initDataTable(
    tableId,
    [
      {
        text: 'Update all hosted zones',
        // action: checkValueAgainstList('manage_dns', permissions) ? triggerAllHostedZonesUpdate : null,
        action: triggerAllHostedZonesUpdate,
        className: 'update-all-zones',
      },
      ...exportButtons(),
      resetTableButton(),
      reloadTableButton(undefined, loadDnsData, 'Reload DNS records (no-cache)'),
    ],
    [
      selectColumn({ width: '20px' }),
      col('fqdn', 'domain_name_col', 'Domain Name', {
        defaultContent: '',
        createdCell: function (td) {
          addCopyButton(td);
          addLinkHostedZoneIdButton(td);
        },
      }),
      col('account_id', 'aws_account_id_col', 'Account ID', {
        defaultContent: '',
        createdCell: function (td, cellData) {
          addCopyButton(td);
          addLoadAccountDetailsButton(td);
          if (!accountIdPattern.test(cellData)) {
            $(td).addClass('portal-danger');
          }
        },
      }),
      col('zone_id', 'zone_id_col', 'Hosted Zone ID', { visible: false }),
      col('zone_type', 'zone_type_col', 'Hosted Zone Type'),
      col('creation_date', 'creation_date_col', 'Creation Date', { visible: false }),
      col('numbers.records', 'records_col', 'Number of Records', { visible: false }),
      col('numbers.ns_records', 'ns_records_col', 'Number of NS Records', { visible: false }),
      col('numbers.vpcs', 'vpcs_col', 'Number of Associated VPCs', { visible: false }),
      col('numbers.query_logging_configs', 'query_logging_configs_col', 'Number of Query Logging Configs', {
        visible: false,
      }),
      col('status', 'status_col', 'Status', {
        defaultContent: 'unknown',
        createdCell: function (td, cellData) {
          addCopyButton(td);
          if (cellData === 'active') {
            $(td).addClass('portal-success');
          } else {
            $(td).addClass('portal-danger');
          }
        },
      }),
      col('status_update', 'status_update_col', 'Last Status Update (UTC)'),
      {
        visible: true,
        defaultContent: '',
        orderable: false,
        searchable: true,
        data: null,
        name: 'actions_col',
        title: 'Actions',
        createdCell: addDNSRowButtons,
        width: '50px',
      },
    ],
    function (row, data) {
      if (data.status === 'AccountDeleted') {
        $(row).addClass('row-deleted');
      } else if (data.status === 'NoSuchHostedZone') {
        $(row).addClass('row-inactive');
      }
    },
    {
      order: [[1, 'asc']],
    },
  );

  // Hide a button if user is not portal admin
  if (!checkValueAgainstList('manage_dns', permissions)) {
    dt.buttons('.update-all-zones').nodes().addClass('d-none');
  }

  rowDetailsClickHandler({ tableId: tableId, rowDetailCallback: formatZoneRow });
  loadDnsData(tableId);
}

/**
 * Enables the "Show All Hosted Zones" switch once loading is complete
 */
function enableShowAllHostedZonesSwitch() {
  $('#show-all-hostedzones-switch').attr('disabled', false);
}
function disableShowAllHostedZonesSwitch() {
  $('#show-all-hostedzones-switch').attr('disabled', true);
}

async function loadDnsData(tableId, headers, forceReload) {
  addSpinner(false);
  addTableSpinner();
  disableShowAllHostedZonesSwitch();
  try {
    const requestHeaders = getRequestHeaders(headers, forceReload);
    await fetchAndProcessDNSData(tableId, requestHeaders);
  } catch (error) {
    displayErrorPopup(error);
  } finally {
    enableShowAllHostedZonesSwitch();
    removeSpinners();
    $(window).trigger('resize');
    scrollToPosition();
  }
}

export function processHostedZoneName(input) {
  // Some external hosted zones have strange octal sequesnces like \303\274 in their names and we need to convert them and then url-encode them before putting it into the querystring.
  // Only decode if backslash-octal patterns are detected
  const needsDecoding = /\\[0-7]{3}/.test(input);

  const decoded = needsDecoding
    ? input.replace(/\\([0-7]{3})/g, (_, octal) => String.fromCharCode(parseInt(octal, 8)))
    : input;

  return encodeURIComponent(decoded);
}

async function formatZoneRow(row) {
  const data = row.data();
  try {
    const hosted_zone_result = await baseApiAxios.getHostedZone(data.fqdn, {}, {});
    row.child(
      <div class="detailsContainer">
        <HostedZoneTabs data={hosted_zone_result} />
      </div>,
    );
    row.child()[0].setAttribute('class', 'rowDetails');
  } catch (err) {
    showErrorFromApiOperation('Fetching Hosted Zone data failed.')(err);
  }
}

function triggerHostedZoneUpdate(row) {
  let data;
  if (typeof row === 'number') {
    const dt = $('#table-zones').DataTable({
      retrieve: true,
    });
    data = dt.row(row).data();
  } else if (typeof row === 'string') {
    data = JSON.parse(row);
  } else {
    data = row;
  }

  const payload = {
    action: 'trigger-update-hostedzone',
    fqdn: data.fqdn,
  };

  addSpinner();
  baseApiAxios.displayResponseAsToast(baseApiAxios.postDnsData(payload), 'Trigger Update');
}

function triggerAllHostedZonesUpdate() {
  const payload = { action: 'trigger-update-all-hostedzones' };
  addSpinner();
  baseApiAxios.displayResponseAsToast(baseApiAxios.postDnsData(payload), 'Trigger Update');
}

export function deleteZoneOrder(row) {
  let data;
  if (typeof row === 'number') {
    const dt = $('#table-zones').DataTable({
      retrieve: true,
    });
    data = dt.row(row).data();
  } else if (typeof row === 'string') {
    data = JSON.parse(row);
  } else {
    data = row;
  }

  let content = document.createElement('div');
  content.innerHTML =
    '<p>Are you sure you want to delete <br><strong>' +
    data.fqdn +
    '</strong><br>from account <strong style="color: red;">' +
    data.account_id +
    '</strong>?</p><p>If you confirm, we will create a new order ' +
    'which will <strong>delete your Route 53 Private Hosted Zone</strong> from your AWS Account ' +
    '<strong>including your currently existing DNS records</strong>!</p>';

  swal({
    title: '! Delete Hosted Zone Order ! - Please ensure the account ID (' + data.account_id + ') is correct',
    content: content,
    icon: 'warning',
    buttons: {
      cancel: {
        text: 'Cancel',
        value: null,
        visible: true,
      },
      reset: {
        text: 'Create Order',
        value: true,
        className: 'swal-button swal-button--confirm swal-button--danger',
      },
    },
    dangerMode: true,
  }).then(function (response) {
    if (response) {
      const payload = {
        action: 'destroy-hostedzone',
        description: 'Destroy hosted zone ' + data.fqdn,
        zone_name: data.fqdn,
        hosted_zone_id: data.zone_id,
        force_deletion: true,
        account_id: data.account_id,
      };
      baseApiAxios.createOrder(payload).then(updateListZonePage);
    }
  });
}

function updateListZonePage(result) {
  removeSpinners();
  switch (result.status) {
    case 200:
      addToast('Create Order', result.data.message, 5000);
      break;
    case 400:
      $('#form-error').html('<strong>Error: </strong>' + result.data.message);
      $('#form-error').show();
      break;
  }
}

export function setZoneInfo() {
  let selected_hz_id = document.getElementById('hosted-zone-id-text');
  let zone_id = document.getElementById('fqdn');
  if (selected_hz_id && zone_id && zone_id.value) {
    selected_hz_id.value = zone_id.value.split(',')[0].split('/')[2];
  }
}

export function loadHostedZones(listId, accountId, nameFilter, isForOnboarding) {
  const loading_hosted_zones = document.querySelector('.loading-form-inline');
  if (loading_hosted_zones) loading_hosted_zones.classList.add('loading-animation');
  let sel = document.getElementById(listId);
  let account_id = document.getElementById(accountId).value.split(';')[0];

  if (account_id) {
    for (let i = sel.options.length - 1; i >= 0; i--) {
      sel.remove(i);
    }

    let payload = {
      action: 'list-hostedzones',
      account_id: account_id,
    };

    if (nameFilter) {
      payload['name_filter'] = nameFilter;
    }

    addSpinner();
    addButtonSpinner();

    baseApiAxios
      .postDnsData(payload, null, { is_for_onboarding: isForOnboarding ? 'true' : 'false' })
      .then(result => {
        $('#fqdn').find('optgroup').remove();
        $('#fqdn').find('option').remove();
        $('#fqdn').find('li').remove();

        let select = document.getElementById(listId);

        if (select.options.length === 0) {
          let placeHolderText = '';
          if (isForOnboarding) {
            placeHolderText =
              result.zones && result.zones.length > 0
                ? '- Select an eligible Private Hosted Zone -'
                : '- No eligible Private Hosted Zones found in the account -';
          } else {
            placeHolderText = '- Select a Hosted Zone -';
          }
          let opt = document.createElement('option');
          opt.value = '';
          opt.innerText = placeHolderText;
          opt.disabled = true;
          opt.selected = true;
          select.appendChild(opt);
        }

        if (result.zones && result.zones.length > 0) {
          jQuery.each(result.zones, function () {
            let opt = document.createElement('option');
            let mainText = this.Name;
            let subText = this.Id + ' (' + this.zone_type + ')';
            opt.value = [this.Id, this.Name];
            opt.innerText = mainText;
            opt.setAttribute('data-name', this.Name);
            opt.setAttribute('data-subtext', subText);
            select.appendChild(opt);
          });
          if (isForOnboarding) {
            $('.onboard-hosted-zone-button').prop('disabled', false);
            $('.onboard-hosted-zone-button').removeClass('btn-disabled-grey');
            $('.onboard-hosted-zone-button').addClass('btn-success');
          }
        } else {
          if (isForOnboarding) {
            $('.onboard-hosted-zone-button').prop('disabled', true);
            $('.onboard-hosted-zone-button').addClass('btn-disabled-grey');
            $('.onboard-hosted-zone-button').removeClass('btn-success');
          }
        }

        setZoneInfo();

        $('.selectpicker').selectpicker('refresh');
        $('.selectpicker').not('.no-deselect').selectpicker('deselectAll');

        select.dispatchEvent(new CustomEvent('dropdown-options-loaded', { detail: { zones: result.zones } }));
      })
      .catch(err => displayError(`<strong>Warning</strong>: ${err.message}`))
      .finally(() => {
        removeSpinners();
        const loading_hosted_zones = document.querySelector('.loading-form-inline');
        if (loading_hosted_zones) loading_hosted_zones.classList.remove('loading-animation');
      });
  }
}

export function checkValidityHostedZone(event) {
  const regexString = event.srcElement.getAttribute('regex-string');
  const re = RegExp(regexString);

  const targetId = event.target.id;
  const selectedItem = $(`#${targetId}`)[0].value;
  let zoneName = selectedItem.substring(selectedItem.indexOf(',') + 1, selectedItem.length);

  if (targetId == 'dns-prefix') {
    zoneName += $('#dns-suffix')[0].textContent;
  }

  if (!re.test(zoneName)) {
    $(`#${targetId}`).removeClass('is-valid');
    $(`#${targetId}-container`).removeClass('is-valid');
    $(`#${targetId}-container`).addClass('is-invalid');
    $(`#${targetId}-invalid-feedback`)[0].textContent =
      `This hosted zone does not meet the requirements. It must match the pattern: ${regexString}`;
    $('#submitButton').prop('disabled', true);
  } else {
    $(`#${targetId}`).removeClass('is-invalid');
    $(`#${targetId}-container`).removeClass('is-invalid');
    $(`#${targetId}-container`).addClass('is-valid');
    $(`#${targetId}-valid-feedback`)[0].textContent = `Domain is valid`;
    $('#submitButton').prop('disabled', false);
  }
}

/**
 * Updated the DNS suffix text field based on the selected zone type and region.
 */
export function changeDNSText() {
  removeSpinners();

  // Collect the current zone type and the available suffix(es) from the dropdown.
  const zoneTypeDropdown = document.querySelector('#zone-type option:checked');
  const zoneType = zoneTypeDropdown.value;
  const zoneSuffix = zoneTypeDropdown.getAttribute('suffix');

  if (zoneType === 'private' && zoneSuffix) {
    // Show the domain name container
    document.getElementById('domain-name').style.display = '';

    // For private hosted zones we need to add the region between the prefix and the suffix.
    const zoneRegion = document.querySelector('#region option:checked').value;
    document.getElementById('dns-suffix').textContent = '.' + zoneRegion + '.' + zoneSuffix;

    // Private hosted zones needs to be associated with a least one VPC in the same AWS account.
    // Here we load the available VPCs from the given AWS account and region.
    centralLoadVPCs('region', 'aws-account-id', centralFillVPCs, { listId: 'network-id-a', disableSharedVPCs: true });
  } else if (zoneType === 'public' && zoneSuffix && zoneSuffix.split(',').length > 0) {
    // Show the domain name container
    document.getElementById('domain-name').style.display = '';

    // Use the first available zone suffix from the list of public zone suffixes.
    document.getElementById('dns-suffix').textContent = '.' + zoneSuffix.split(',')[0];
  } else {
    // Hide the domain name container if something goes wrong
    document.getElementById('domain-name').style.display = 'none';
    swal({
      title: 'Missing DNS configuration',
      text: `The zone type "${zoneType}" is not (yet) supported or the target DNS configuration is missing.`,
      icon: 'error',
    });
  }
}

export function updateZoneType() {
  let zoneType = $('#zone-type')[0].value;
  $('#dns-prefix').prop('required', true);

  if (zoneType === 'private') {
    loadRegionsAndUpdateDropdown(zoneType, ['region']);
    $('#private-zone-region').show();
    $('#private-vpc-id').show();

    $('#region').prop('required', true);
    $('#network-id-a').prop('required', true);
  } else {
    $('#private-zone-region').hide();
    $('#private-vpc-id').hide();

    $('#region').prop('required', false);
    $('#network-id-a').prop('required', false);
    changeDNSText();
  }
}

export function checkHostedZone(callback) {
  let dnsPrefix = $('#dns-prefix')[0].value;
  let dnsSuffix = $('#dns-suffix')[0].textContent;
  const dnsPrefixPattern = /^[a-z0-9][a-z0-9._-]{1,200}[a-z0-9]$/;

  const targetId = 'dns-prefix';

  if (!dnsPrefixPattern.test(dnsPrefix)) {
    $(`#${targetId}`).removeClass('is-valid');
    $(`#${targetId}`).addClass('is-invalid');

    $(`#${targetId}-invalid-feedback`)[0].textContent =
      'Please enter a valid domain prefix with the following pattern: ' + dnsPrefixPattern;

    $(`#${targetId}-container`).removeClass('is-valid');
    $(`#${targetId}-container`).addClass('is-invalid');
  } else {
    const dnsURL = dnsPrefix + dnsSuffix;
    const payload = {
      action: 'check-hostedzone',
      zone_name: dnsURL,
    };

    baseApiAxios
      .postDnsData(payload)
      .then(result => {
        callback(result);
      })
      .catch(err => {
        $(`#${targetId}`).removeClass('is-valid');
        $(`#${targetId}`).addClass('is-invalid');

        $(`#${targetId}-container`).removeClass('is-valid');
        $(`#${targetId}-container`).addClass('is-invalid');

        $(`#${targetId}-invalid-feedback`)[0].textContent = err.response?.data?.message;
      });
  }
}

export function callCheckHostedZone(dnsURL) {
  const payload = {
    action: 'check-hostedzone',
    zone_name: dnsURL,
  };
  addButtonSpinner();

  const submitButton = document.getElementById('submitButton.onboard-hosted-zone-button');

  baseApiAxios
    .postDnsData(payload)
    .then(() => {
      submitButton.disabled = false;
    })
    .catch(() => {
      submitButton.disabled = true;
    })
    .finally(() => removeSpinners());
}

export function showHostedZoneAvailability(result) {
  $('#dns-prefix').removeClass('is-invalid');
  $('#dns-prefix').addClass('is-valid');
  $('#dns-prefix-valid-feedback')[0].textContent = result.message;
}

export function submitHostedZoneOrder() {
  const dnsPrefix = $('#dns-prefix')[0].value;
  const dnsSuffix = $('#dns-suffix')[0].textContent;
  const zoneType = $('#zone-type')[0].value;

  let payload = {
    action: 'create-hostedzone',
    description: 'Create hosted zone ' + dnsPrefix + dnsSuffix,
    account_id: $('#aws-account-id')[0].value.split(';')[0],
    zone_name: dnsPrefix + dnsSuffix,
    zone_type: zoneType,
  };

  if (zoneType === 'private') {
    payload['region'] = $('#region')[0].value;
    payload['vpc_id'] = $('#network-id-a')[0].value;
  }

  baseApiAxios
    .createOrder(payload)
    .then(orderResponse => {
      addToast('Create Order', orderResponse.message, 6000);

      const form = document.getElementById('create-route53-hosted-zone-form');
      $('#domain-name').hide();
      $('#private-zone-region').hide();
      $('#private-vpc-id').hide();
      form.reset();
      $('#dns-prefix').removeClass('is-valid');
      $('#dns-prefix').removeClass('is-invalid');
      $('#dns-prefix-invalid-feedback')[0].textContent = '';
      $('#dns-prefix-valid-feedback')[0].textContent = '';
      $('.selectpicker').selectpicker('refresh');
      $('.selectpicker').not('.no-deselect').selectpicker('deselectAll');
      $('#dns-prefix').prop('required', false);
      $('#region').prop('required', false);
      $('#network-id-a').prop('required', false);
      updateZoneType();
    })
    .catch(orderError => {
      showError(orderError);
    });
}

export function resultAssociateHostedZoneFunction(result) {
  removeSpinners();
  displaySuccessPopup(result.message, 'Create Order');
  $('#aws-account-id').val('');
  $('#hosted-zone-id').val('');
  $('#aws-account-id-b').val('');
  $('#network-id-a').val('');
  $('.selectpicker').not('.no-deselect').selectpicker('deselectAll');
  $('.selectpicker').selectpicker('refresh');
}

export function resultOnboardHostedZoneFunction(result) {
  removeSpinners();
  displaySuccessPopup(result.message, 'Create Order');
  $('#aws-account-id').val('');
  $('#hosted-zone-id').val('');
  $('.selectpicker').not('.no-deselect').selectpicker('deselectAll');
  $('.selectpicker').selectpicker('refresh');
}

/**
 * Collect the DNS configuration from the backend and add the hosted zone options (private/public) to the dropdown
 * depending on the available private/public domain suffixes and the selected AWS account type.
 *
 * @param {string} _searchParam
 * @param {string} _label
 * @param {object} _selectedOption
 * @param {string} _accountId
 * @param {string} accountType
 * @param {string} _accountStage
 */
export function updateAvailableZoneTypesDropdown(
  _searchParam,
  _label,
  _selectedOption,
  _accountId,
  accountType,
  _accountStage,
) {
  // Show the Hosted Zone Type dropdown once the AWS account was selected
  document.getElementById('zone-type-container').style.display = '';

  addSpinner();
  addButtonSpinner();

  // Collect the DNS configuration from the backend
  baseApiAxios.getDnsConfig().then(config => {
    const private_hosted_zones_account_types = config.private_hosted_zones_account_types || [];
    const public_hosted_zones_account_types = config.public_hosted_zones_account_types || [];
    const private_domain_suffix = config.private_domain_suffix || undefined;
    const public_domains = config.public_domains || [];

    // Update the info text with the currently configured values from the backend
    if (private_hosted_zones_account_types) {
      document.getElementById('zone-type-infobox-private-account-types').textContent =
        private_hosted_zones_account_types.join(', ');
    }
    if (public_hosted_zones_account_types) {
      document.getElementById('zone-type-infobox-public-account-types').textContent =
        public_hosted_zones_account_types.join(', ');
    }

    // Get the zone type dropdown and reset to the available items
    const select = document.getElementById('zone-type');
    removeDisabledOptions(select);

    // Prepare and add the option for private hosted zones
    // Adds the private domain suffix as an attribute to the option
    if (private_domain_suffix && private_hosted_zones_account_types.includes(accountType)) {
      let opt = document.createElement('option');
      opt.innerText = 'Private Hosted Zone';
      opt.value = 'private';
      opt.setAttribute('suffix', private_domain_suffix);
      select.appendChild(opt);
    }

    // Prepare and add the option for public hosted zones
    // Adds the public domain suffixes as a comma-separated list to the option
    if (public_domains && public_domains.length > 0 && public_hosted_zones_account_types.includes(accountType)) {
      let opt = document.createElement('option');
      opt.innerText = 'Public Hosted Zone';
      opt.value = 'public';
      opt.setAttribute('suffix', public_domains.join(','));
      select.appendChild(opt);
    }

    removeSpinners();
    $('.selectpicker').selectpicker('refresh');
    updateZoneType();
  });
}

/**
 * Clears the hosted zones table
 *
 * @param {string} tableId - ID of the table to clear
 */
function clearHostedZonesTable(tableId) {
  const dt = $('#' + tableId).DataTable();
  dt.clear().draw();
}

/**
 * Gets request headers, adding cache control if needed
 *
 * @param {Object} headers - Original headers
 * @param {boolean} forceReload - Whether to force a reload bypassing cache
 * @returns {Object} Headers object with cache control if needed
 */
function getRequestHeaders(headers = {}, forceReload) {
  if (forceReload) {
    return {
      ...headers,
      'Cache-Control': 'max-age=0, must-revalidate',
    };
  }
  return headers;
}

/**
 * Fetches and processes DNS data with retry capability
 *
 * @param {string} tableId - ID of the table to populate
 * @param {Object} headers - Request headers
 */
async function fetchAndProcessDNSData(tableId, headers) {
  let dns_search_enable = isSearchEnabled('dns_search_enable');
  let retryCount = 0;
  const maxRetries = 1; // Allow one retry with different search method

  while (retryCount <= maxRetries) {
    try {
      await fetchDNSDataWithPagination(tableId, dns_search_enable, headers);
      break; // Success, exit the retry loop
    } catch (error) {
      if (dns_search_enable && retryCount < maxRetries) {
        // Switch to DynamoDB if OpenSearch fails
        console.warn('OpenSearch returned an error, retrying fetch DNS search with dynamodb');
        dns_search_enable = false;
        sessionStorage.setItem('dns_search_enable', 'false');
        clearHostedZonesTable(tableId);
        retryCount++;
      } else {
        // We've already tried both methods or reached max retries
        throw error;
      }
    }
  }
}

/**
 * Fetches DNS data with pagination handling
 *
 * @param {string} tableId - ID of the table to populate
 * @param {boolean} dns_search_enable - Whether to use OpenSearch
 * @param {Object} headers - Request headers
 */
async function fetchDNSDataWithPagination(tableId, dns_search_enable, headers) {
  const listFields = hostedZonesDetailsAttributes.join(',');
  const requestParams = {
    fields: listFields,
    size: 2000,
    list_all: dashboardShowAllHostedZones,
  };

  const dt = $('#' + tableId).DataTable();
  // Use a Set for O(1) duplicate lookups instead of scanning the full table on every batch
  const seenFqdns = new Set(
    dt
      .rows()
      .data()
      .toArray()
      .map(item => item.fqdn),
  );

  // Initial request
  let response = await fetchDNS(dns_search_enable, headers, requestParams);
  let { items, next_token } = response;

  // Process first batch of items (add rows without drawing)
  appendDNSDataFast(dt, items, seenFqdns);

  // Continue processing pagination if there are more items
  while (next_token) {
    response = await fetchDNS(dns_search_enable, headers, {
      ...requestParams,
      next_token,
    });

    items = response.items;
    next_token = response.next_token;

    appendDNSDataFast(dt, items, seenFqdns);
  }

  // Single draw + footer rebuild after all pages are loaded
  dt.columns.adjust().draw(false);
  updateDNSTableFooter(tableId);
}

/**
 * Adds DNS items to the DataTable without drawing. Uses a shared Set for
 * O(1) duplicate detection instead of scanning the table on every batch.
 *
 * @param {Object} dt - DataTable instance
 * @param {Array} new_items - New DNS items to append
 * @param {Set} seenFqdns - Set of already-added fqdn values
 */
function appendDNSDataFast(dt, new_items, seenFqdns) {
  if (!new_items || new_items.length === 0) {
    return;
  }

  const items_to_append = [];
  for (const item of new_items) {
    if (!seenFqdns.has(item.fqdn)) {
      seenFqdns.add(item.fqdn);
      items_to_append.push(item);
    }
  }

  if (items_to_append.length > 0) {
    dt.rows.add(items_to_append);
  }
}

function updateDNSTableFooter(tableId) {
  updateTableFooter(tableId, zoneTableColumns, dnsDropdownColumns, dnsSearchColumns, dnsSearchColumnsNumbers);
}
